export default {
  companyTypes: state => state.company_types,
  companyBranches: state => state.branches,
  currentBranch: state => state.current_branch,
  currentBranchBankCard: state => state.current_branch.bank_card,
  currentBranchBankAccount: state => state.current_branch.bank_account,
  currentBranchEmployees: state => state.current_branch_employees,
  currentSidebarItems: state => state.current_sidebar_items,
  currentBranchPayments: state => state.current_payments,
  currentBranchPayments_order: state => state.current_payments_order,
  currentPaymentsPages: state => state.currentPaymentsPages,
  currentTotalAmountRubles: state => state.currentTotalAmountRubles,
  currentSuccessAmountRubles: state => state.currentSuccessAmountRubles
}
